<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="title"><span class="colorFB092B">中国(四川)</span><span>单一窗口</span></div>
            <div class="sec-title"><span>sichuan</span><br> <span>single window</span> </div>
            <div class="text-video-box">
                <div class="video-box">
                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="false" :options="playerOptions"></video-player>
                    <!-- <img src="../assets/images/play.png" alt="" width="64px" height="64px"> -->
                </div>
                <div class="text-box">
                    <p class="text-title">什么是“单一窗口”</p>
                    <p class="text mgb40">“单一窗口”是指参与国际贸易和运输的各方，通过单一接入点提交标准化的信息和单证，以满足相关法律法规及管理的要求。</p>
                    <p class="text">在实现“一个平台、一次申报、统一标准”的基础上，深化拓展“单一窗口”应用功能，覆盖国际贸易管理全链条，打造“一站式”贸易服务平台，并积极参与制定国际贸易新规则，推进与境外“单一窗口”互联互通。</p>
                    <div class="btn-go" @click="goPage">
                  
                        <el-link :underline="false">前往四川单一窗口</el-link>
                          <img src="../assets/images/right_icon.png" alt="" width="25px" height="25px">
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import top_active from "../assets/images/top_active.png"
import top_default from "../assets/images/top_default.png"
// import video from '@/assets/video.mp4'
export default {
    name: "tagSc",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            list: [],
            //videoSrc:video,
            default_icon: top_default,
            active_icon: top_active,
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], //可选择的播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: true, // 视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: "",
                    src: "https://zy-web.oss-cn-beijing.aliyuncs.com/video.mp4" //url地址
                }],
                poster: "https://zy-web.oss-cn-beijing.aliyuncs.com/video_img.png", //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, //当前时间和持续时间的分隔符
                    durationDisplay: true, //显示持续时间
                    remainingTimeDisplay: true, //是否显示剩余时间功能
                    fullscreenToggle: true //全屏按钮
                }
            }
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        goPage(){
            //window.location.href="http://sc.singlewindow.cn/";
            window.open('http://sc.singlewindow.cn/','_blank')
            //window.location.target='_blank'
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.video-player {
    width: 100%;
    height: 100%;
    //border:1px red solid;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        //background-color: #ccc;
        //padding-left: 240px;
        display: flex;
        justify-content: center;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            //border: 1px red solid;
            display: flex;
            flex-direction: column;
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {
    margin-top: 80px;
    color: #fff;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 84px;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.75);
    line-height: 26px;
}

.text-video-box {
    margin-top: 50px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: space-between;
    align-items: flex-start;
}

.video-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    //border: 1px red solid;
    border-radius: 10px;
    display: flex;
    min-height: 360px;
    justify-content: center;
    align-items: center;
}

.text-box {
    width: 45%;
    min-width: 640px;
    height: 70%;
    min-height: 360px;
    //border: 1px red solid;
    padding: 0 20px;

}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FB092B;
    line-height: 42px;
    margin-bottom: 40px;
}

.text {
    width: 640px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    text-align: justify;
    line-height: 32px;
}

.mgb40 {
    margin-bottom: 40px;
}

.btn-go {
    width:160px;
    font-size: 16px;
    line-height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    a {
    margin-left: 10px;
    //margin-right: 30px;
        color: white !important;
    }
    .img{
    
    }

    a:hover {}
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/tagSc.vue